module.exports = __webpack_public_path__ + "static/media/logo.a8016b73.jpg";